import { IsNotEmpty, IsNumber, IsOneOfThese, IsValidDate } from '@core/services/csv/CSVCustomValidator'
import { CSVModelInterface } from '@core/services/csv/CSVModel.interface'
import { DateService } from '@master/services/DateService'
import { CommissionData } from '../../api'
import { Expose, Transform } from 'class-transformer'
import { ValidateIf } from 'class-validator'
import { isEmpty } from 'lodash'
import { parseFloatNumber } from '@core/services/csv/CSVTransformer'
import { FrequencyList, FrequencyToValueMapping, FrequencyType } from '@master/model/options/FrequencyOptions'
import { productTypes } from '@master/model/options/LineOfBusinessOptions'

const dateService = new DateService()

export class TokioTransactionCsvModel extends CSVModelInterface implements CommissionData {
  @Expose()
  @IsNotEmpty()
  private 'AdviserNo' = 'CODE 123'

  get advCode () {
    return this.AdviserNo
  }

  @Expose()
  private Name = 'Wen Adviser'

  get advName () {
    return this.Name
  }

  @Expose()
  @IsNotEmpty()
  private Reference = 'Policy 123'

  get policyNumber () {
    return this.Reference
  }

  @Expose()
  private ClientName = 'John Doe'

  get clientName () {
    return this.ClientName
  }

  @Expose()
  private NRIC = 'S1234567G'

  get clientNric () {
    return this.NRIC
  }

  @Expose()
  private CompCode = 'ABC001'

  get componentCode () {
    return this.CompCode
  }

  @Expose()
  private PlanName = 'Life Insurance Name'

  get productName () {
    return this.PlanName
  }

  @Expose()
  @IsNotEmpty()
  @IsOneOfThese(productTypes)
  private 'Product Type' = '[' + productTypes + ']'

  get productType () {
    return this['Product Type']
  }

  @Expose()
  @ValidateIf(o => !isEmpty(o.premiumCurrency))
  @IsOneOfThese(['SGD', 'CHF', 'EUR', 'GBP', 'USD', 'AUD', 'JPY', 'HKD'])
  private 'Currency' = 'SGD'

  get premiumCurrency () {
    return this.Currency
  }

  @Expose()
  @Transform(({ value }) => parseFloatNumber(value))
  @IsNumber()
  private 'InstallmentPremium' = 123.45

  get installmentPremium () {
    return this.InstallmentPremium
  }

  @Expose()
  @Transform(({ value }) => parseFloatNumber(value))
  @IsNumber()
  private 'LoadedInstallmentPremium' = 123.45

  get loadingPremium () {
    return this.LoadedInstallmentPremium
  }

  get premiumAmt () {
    return this.installmentPremium + this.loadingPremium
  }

  @Expose()
  @ValidateIf(o => !isEmpty(o.premiumPurpose))
  @IsOneOfThese(['RP', 'SP', 'RSP', 'TOP-UP'])
  private 'Prem Typ' = 'RP'

  get premiumPurpose () {
    return this['Prem Typ']
  }

  @Expose()
  @IsOneOfThese(FrequencyList.filter(frequency => !['RSP', 'Single'].includes(frequency)))
  private 'BillingFrequency' = 'Monthly'

  get payMode () {
    return FrequencyToValueMapping(this.BillingFrequency as FrequencyType)
  }

  @Expose()
  @ValidateIf(o => !isEmpty(o.approvedDate))
  @IsValidDate('DD/MM/YYYY')
  private 'CommencementDate' = '31/12/2020'

  get approvedDate (): number {
    return dateService.toUnixMilliseconds(this.CommencementDate, 'DD/MM/YYYY')
  }

  @Expose()
  @ValidateIf(o => !isEmpty(o.approvedDate))
  @IsValidDate('DD/MM/YYYY')
  private 'EffectiveDate' = '31/12/2020'

  get effectiveDate (): number {
    return dateService.toUnixMilliseconds(this.EffectiveDate, 'DD/MM/YYYY')
  }

  @Expose()
  @ValidateIf(o => !isEmpty(o.basicCommission))
  @Transform(({ value }) => parseFloatNumber(value))
  @IsNumber()
  private 'OriginalAmount' = 123.45

  get commissionForeignCurrency () {
    return `${this.OriginalAmount}`
  }

  @Expose()
  @ValidateIf(o => !isEmpty(o.basicCommission))
  @Transform(({ value }) => parseFloatNumber(value))
  @IsNumber()
  private 'BasicPremiumCommission' = 123.45

  get basicCommission () {
    return this.BasicPremiumCommission
  }

  @Expose()
  @ValidateIf(o => !isEmpty(o.basicCommission))
  @Transform(({ value }) => parseFloatNumber(value))
  @IsNumber()
  private 'LoadedPremiumCommission' = 123.45

  get loadedCommission () {
    return this.LoadedPremiumCommission
  }

  @Expose()
  @Transform(({ value }) => parseFloatNumber(value))
  @IsNumber()
  private 'ActualAmount' = 123.45

  @Expose()
  @Transform(({ value }) => parseFloatNumber(value))
  @IsNumber()
  private 'Commission' = 123.45

  get commissionAmt () {
    return this.ActualAmount || this.Commission
  }

  @Expose()
  @Transform(({ value }) => parseFloatNumber(value))
  @IsNumber()
  private 'OverridingCommission' = 123.45

  get orCommissionAmt () {
    return this.OverridingCommission
  }

  @Expose()
  private 'Transaction' = '1st Year Commission - Premium Collection'

  @Expose()
  private 'Fee Type' = 'FYC-First'

  @Expose()
  private 'Description' = 'FYC-First'

  get descriptions () {
    if (this.Commission) {
      const transaction = this.Transaction
      const separator = transaction.indexOf('-') - 1
      return separator > 0 ? transaction.slice(0, separator) : ''
    } else {
      return this['Fee Type']
    }
  }

  get remark () {
    if (this.Commission) {
      const transaction = this.Transaction
      const separator = transaction.indexOf('-') + 1
      return separator > 0 ? transaction.slice(separator + 1) : ''
    } else {
      return this.Description
    }
  }
}
